import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/logo.svg'


const _hoisted_1 = { class: "sidebar_bg" }
const _hoisted_2 = { class: "user-info" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "menu-wrap" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

import PersonalMenu from '@/layouts/component/PersonalMenu.vue';
import WorkSpaceMenu from '@/layouts/component/WorkSpaceMenu.vue';
import user1 from '@/assets/icon/persona/user1.svg';
import logout from '@/assets/icon/menu/logout.svg';

import { computed } from 'vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'SideBar',
  setup(__props) {

const route = useRoute();

const isPersonalMenu = computed(() => route.path.startsWith('/my'));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "logo_area" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "logo"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(user1),
        alt: "persona"
      }, null, 8, _hoisted_3),
      _cache[1] || (_cache[1] = _createElementVNode("p", { class: "ubuntu-medium" }, " Minionz ", -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, [
        (isPersonalMenu.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(PersonalMenu)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(WorkSpaceMenu)
            ]))
      ]),
      _createElementVNode("div", null, [
        _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("button", {
          class: "logout-wrap",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(logout) && _unref(logout)(...args)))
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "logout-ico" }, null, -1),
          _createTextVNode(" Logout ")
        ]))
      ])
    ])
  ]))
}
}

})